/**
 * Shortens an Ethereum address by keeping a specified number of characters at the start and end.
 * @function shortenEthAddress
 * @param {string} address - The Ethereum address to shorten.
 * @param {number} [frontChars=3] - The number of characters to keep at the start of the address.
 * @param {number} [backChars=4] - The number of characters to keep at the end of the address.
 * @returns {string} The shortened Ethereum address.
 */
export function shortenEthAddress(
  address: string,
  frontChars?: number,
  backChars?: number,
): string {
  if (!address) return '';

  const frontVal = frontChars || 3;
  const backVal = backChars || 4;
  return `${address.substring(0, frontVal)}...${address.substring(
    42 - backVal,
  )}`;
}
